import { Card, Group, Skeleton, Stack, useMantineTheme } from '@mantine/core';
import { memo } from 'react';

export const AiImpactWidgetSkeleton = memo(
	({ halfWidth }: { halfWidth?: boolean }) => {
		const theme = useMantineTheme();

		return (
			<Card
				p={theme.spacing.xs}
				h="100%"
				w={halfWidth ? '50%' : '100%'}
				withBorder
				style={{ borderRadius: theme.radius.md }}
			>
				<Stack spacing="sm">
					<Group position="apart" pt="sm" pr="sm" pb="sm" pl="md">
						<Group spacing="sm">
							<Skeleton height={16} width={16} circle />
							<Skeleton height={16} width={120} />
						</Group>
						<Skeleton height={32} width={100} />
					</Group>
					<Stack spacing="md" px="md" pb="md">
						{[1, 2, 3, 4].map((i) => (
							<Group key={i} position="apart" noWrap>
								<Group spacing="sm" style={{ flex: 1, minWidth: 0 }}>
									<Skeleton height={32} width={32} circle />
									<Stack spacing={4} style={{ flex: 1, minWidth: 0 }}>
										<Skeleton height={14} width="60%" />
										<Skeleton height={12} width="80%" />
									</Stack>
								</Group>
								<Skeleton height={14} width={30} />
							</Group>
						))}
					</Stack>
					<Group position="right" pr="sm" pb="sm">
						<Skeleton height={14} width={80} />
					</Group>
				</Stack>
			</Card>
		);
	}
);
